import React from "react";
import { Tooltip, Typography } from "@mui/material";

interface TimestampDisplayProps {
  timestamp: string | Date;
  variant?: "body2" | "caption" | "inherit";
  color?: "text.primary" | "text.secondary" | "inherit";
  fontFamily?: string;
}

export function TimestampDisplay({ 
  timestamp, 
  variant = "body2", 
  color = "text.secondary",
  fontFamily = "monospace" 
}: TimestampDisplayProps) {
  const date = new Date(timestamp);
  const rawTimestamp = date.toISOString();
  const formattedDate = date.toLocaleString();

  return (
    <Tooltip title={formattedDate} placement="top">
      <Typography
        variant={variant}
        color={color}
        sx={{
          fontFamily,
          fontSize: "0.85em",
          cursor: "pointer",
          textDecoration: "underline dotted",
          textDecorationColor: "currentColor",
          textUnderlineOffset: "2px",
        }}
      >
        {rawTimestamp}
      </Typography>
    </Tooltip>
  );
}